import './utils/imagePreloader'; // Load this first to start preloading before React
import './utils/builderLocale'; // Initialize domain-based locale detection for Builder.io fallback
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { EditryAdminOverlay, EditryProvider } from '@lazylabs-dev/editry-react';
import { editryConfig } from './editry/config';

const AppWithScrollbar = () => {
  return (
    <div>
      <App/>
    </div>
  );
};

function EditryChrome() {
  const { pathname } = useLocation();
  const normalized = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  const onLogin = normalized === '/login';

  return (
    <EditryAdminOverlay
      key={onLogin ? 'login' : 'site'}
      loginPathname="/login"
      currentPathname={normalized}
      initiallyExpanded={onLogin}
      showSecretTokenField={false}
    />
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EditryProvider config={editryConfig} persistAdminSession initialUiTheme="light">
      <Router>
        <EditryChrome />
        <AppWithScrollbar/>
      </Router>
    </EditryProvider>
  </React.StrictMode>
);

reportWebVitals();
